$(document).ready(function() {
    //public-private
    // let typeAccountSwitcher = $('#type-account-switch');
    // function typeAccount(){
    //     if (typeAccountSwitcher.is(':checked')) {
    //         $('.js-change-public-type').removeClass('text-disabled').addClass('text-active');
    //         $('.js-change-private-type').removeClass('text-active').addClass('text-disabled');
    //     } else {
    //         $('.js-change-private-type').removeClass('text-disabled').addClass('text-active');
    //         $('.js-change-public-type').removeClass('text-active').addClass('text-disabled');
    //     }
    // }
    // typeAccountSwitcher.on('change', function (e) {
    //     typeAccount()
    // });
    // typeAccount()
})


